import React from "react";
import {connect} from "react-redux";

import Coterie from '../scripts/button';

class CoterieButton extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        var request = {
            "token": "a4759c23-da8d-47c4-aa5c-230b285cab71",
            "environment": "sandbox",
            "text": "Get a Quote from Coterie",
            "applicationType": "GL",
            "glLimit": "1000000",
            "policyStartDate": "3/1/2019",
            "policyEndDate": "3/1/2020",
            "industryId": "10007",
            "annualPayroll": "150000",
            "grossAnnualSales": "200000",
            "numEmployees": "1",
            "contactFirstName": "Joe",
            "contactLastName": "Parker",
            "contactEmail": "joe.parker@example.com",
            "contactPhone": "513-555-6473",
            "mailingAddressStreet": "500 North Michigan, Suite 600",
            "mailingAddressCity": "Chicago",
            "mailingAddressState": "IL",
            "mailingAddressZip": "60002",
            "locations": [
                {
                    "street": "500 North Michigan, Suite 600",
                    "city": "Chicago",
                    "state": "IL",
                    "zip": "60002"
                }
            ],
            ...this.props
        };
        this.instance.appendChild(Coterie.createCoterieButton(request));
    }

    render() {
        return <a ref={el => (this.instance = el)} />;
    }
}

export default connect()(CoterieButton);
